module.exports = __webpack_public_path__ + "static/media/outlook.89ba856f.png";